import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderDark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={12}
    fill="none"
    viewBox="0 0 14 12" {...props}
  >
    <path
      fill="#258695"
      d="M0 1.179C0 .528.534 0 1.192 0h2.98c.33 0 .597.264.597.59s.267.589.596.589h5.96c.66 0 1.193.528 1.193 1.179v7.663c0 .651-.534 1.18-1.192 1.18H1.192A1.186 1.186 0 0 1 0 10.02z"
    />
    <path
      fill="url(#Folder-Dark_svg__a)"
      d="M.82 3.458c.042-.619.562-1.1 1.19-1.1h9.83c.69 0 1.235.577 1.19 1.257l-.438 6.485c-.042.62-.562 1.1-1.19 1.1h-9.83c-.69 0-1.235-.577-1.19-1.257z"
    />
    <path
      fill="#258695"
      d="M1.276 4.451a1.19 1.19 0 0 1 1.162-.914h10.37c.766 0 1.333.705 1.16 1.444l-1.237 5.306a1.19 1.19 0 0 1-1.162.913H1.2A1.182 1.182 0 0 1 .038 9.756z"
    />
    <defs>
      <linearGradient
        id="Folder-Dark_svg__a"
        x1={6.706}
        x2={6.706}
        y1={2.358}
        y2={11.2}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity={0.5} />
        <stop offset={1} stopColor="#fff" stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
);
export default SvgFolderDark;
